import { Button, Container, HStack, Heading, Image, Input, Link, Stack, Text, VStack } from '@chakra-ui/react'
import React, { useState } from 'react'
const Course=({views,title,imageSrc,id,addToPlayListHandler,Creator,description,lectureCount})=>{
return(
<VStack className='course' alignItems={['center','flex-start']}>
<Image src={imageSrc} boxSize='60' objectFit={'contain'}/>
<Heading textAlign={['center','left']} size={'sm'} maxW="200px" fontFamily={"sans-serif"} noOfLines={3} children={title}/>
<Text noOfLines={2} children={description}/>
<HStack>
<Text fontWeight={'bold'} textTransform='uppercase' children={"Creator"}/>

<Text fontFamily={'body'} textTransform='uppercase' children={Creator}/>
</HStack>
<Heading textAlign={'center'} size='xs' children={`Lectures - ${lectureCount}`} />
<Heading  size='xs' children={`Views - ${views}`} />
<Stack direction={['column','row']} alignItems='center'>
<Link to={`/course/${id}`}>
    <Button  colorScheme={'yellow'}>Watch Now</Button>
</Link>
<Button variant={'ghost'} colorScheme={'yellow'} onClick={()=>addToPlayListHandler(id)}>Add to playlist</Button>
</Stack>
</VStack >
)
}
const Courses = () => {
 const [keyword, setKeyword] = useState('')
 const [category, setCategory] = useState('')
 const addToPlayListHandler=()=>{
    console.log('Add to Playlist')
 }
 const categories=[
    "Web Development","Artificial Intellegence","Data Structure & Algorithm","Data Science","App Development","Many More"
 ]
  return (
    <Container minH={'95vh'} maxW='container-lg' paddingY={'8'}>
        <Heading children="All Courses" m={'8'}/>
        <Input value={keyword} onChange={(e)=>setKeyword(e.target.value)} placeholder='Search a course....' type={'text'} focusBorderColor='yellow.500'/>
        <HStack overflowX={'auto'} padding='8' css={{
            '&::-webkit-scrollbar':{
                display:'none'
            }
        }}>
            { 
                categories.map((item,index)=>(
                  
                    <Button key={index} minW={'60'} onClick={()=>setCategory(item)}>
                <Text children={item}/>
            </Button>
                ))
            }
        </HStack>
        <Stack direction={["column","row"]} flexWrap="wrap" justifyContent={['flex-start',"space-evenly"]} alignItems={["center","flex-start"]}>
<Course
title={"Sample"}
views={23}
imageSrc={"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwi1eyqtIciwEPXwvl78mSQ3nmuhjHktD5Kg&usqp=CAU"}
id={"Sample"}

Creator={"Sample"}
description={"Sample"}
lectureCount={2}
addToPlayListHandler={addToPlayListHandler}


/>
        </Stack>
    </Container>
  )
}

export default Courses